import { SET_NAVIGATOR_ONLINE } from 'reducers/actions-types';

export default Object.freeze({
    /**
     * Set network state
     * @param {boolean} isOnline
     * @return {{isOnline: *, type: *}}
     */
    setNetworkState({ isOnline }) {
        return { type: SET_NAVIGATOR_ONLINE, isOnline };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/navigator/actions.js